import {useQuery} from '@tanstack/react-query'
import {useCallback} from 'react'

import {getFeaturesMenu} from '../../api/endpoints'
import {FeaturesMenu} from '../../api/types/featuresMenu'
import {getHomeFeature} from '../features-menu/getHomeFeature'

export const useFeaturesMenu = ({plantUpmId}: {plantUpmId?: string} = {}) => {
  const selectFeaturesMenu = useCallback(
    (data: FeaturesMenu) => ({
      homeFeature: getHomeFeature(data),
      featuresMenu: data
    }),
    []
  )

  const {data, isLoading, error} = useQuery({
    // the unfiltered key stays as-is so the LoginGuard prefetch keeps matching
    queryKey: plantUpmId ? ['featuresMenu', plantUpmId] : ['featuresMenu'],
    queryFn: async () => {
      const response = await getFeaturesMenu(plantUpmId)
      return response.data
    },
    select: selectFeaturesMenu,
    refetchOnWindowFocus: false,
    throwOnError(error) {
      // a plant-scoped lookup is advisory, so it must never break the page
      if (plantUpmId || error.response?.status === 404) {
        return false
      }
      return true
    }
  })

  const isFeatureMenuNotFound = error?.response?.status === 404
  const {homeFeature, featuresMenu} = data ?? {}

  return {
    homeFeature,
    featuresMenu,
    isLoading,
    isFeatureMenuNotFound,
    isError: Boolean(error)
  }
}
